module.exports = __webpack_public_path__ + "img/person.85969c8b.svg";